<template>
  <div class="new-domain-banner-trademark">
    <div class="banner-img">
      <div class="link-switch fix pt30">
        <a class="fl"
           href="/domain">注册域名</a>
        <a class="fl"
           href="/trademark">注册商标</a>
      </div>
      <br>
      <span class="banner-title">商标注册</span><br>
      <span class="banner-title-sub">极速申报，专业专注，全流程指导，1对1跟进，一站式服务</span>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
}
</script>
<style lang="scss">
.new-domain-banner-trademark {
  background: #070438;

  .banner-img {
    height: 280px;
    background: url(../../static/assets/new-banner.png);
    width: 1200px;
    margin: auto;
    text-align: center;

    span {
      display: inline-block;
    }
  }

  .banner-title {
    /* line-height: 280px; */
    margin-top: 30px;
    color: #fff;
    font-size: 36px;
  }
  .banner-title-sub {
    margin-top: 30px;
    width: 576px;
    color: #fff;
    font-size: 18px;
    line-height: 46px;
    border: 1px dotted #7caaff;
  }
  .link-switch {
    // float: left;
    font-size: 0;
    margin-left: 60px;

    a {
      display: inline-block;
      color: #fff;
      font-size: 12px;
      height: 26px;
      line-height: 26px;
      width: 90px;
      text-align: center;
      background: #18425e;
    }

    a:first-child {
      background: #1e9f95;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/new-header-trademark.vue